import { render, staticRenderFns } from "./form-item.vue?vue&type=template&id=b6f3db6c&"
import script from "./form-item.vue?vue&type=script&lang=js&"
export * from "./form-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6f3db6c')) {
      api.createRecord('b6f3db6c', component.options)
    } else {
      api.reload('b6f3db6c', component.options)
    }
    module.hot.accept("./form-item.vue?vue&type=template&id=b6f3db6c&", function () {
      api.rerender('b6f3db6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/form/src/form-item.vue"
export default component.exports